// src/utils/constants.js

export const STATUS_COLUMNS = [
  { id: 'NEW', title: 'New', color: 'bg-red-50 border-red-200' },
  { id: 'IN_PROGRESS', title: 'In Progress', color: 'bg-yellow-50 border-yellow-200' },
  { id: 'RESOLVED', title: 'Resolved', color: 'bg-green-50 border-green-200' },
  { id: 'CLOSED', title: 'Closed', color: 'bg-gray-50 border-gray-200' }
];

export const PRIORITY_COLORS = {
  LOW: 'bg-green-100 text-green-600',
  MEDIUM: 'bg-yellow-100 text-yellow-600',
  HIGH: 'bg-orange-100 text-orange-600',
  URGENT: 'bg-red-100 text-red-600'
};

export const STATUS_COLORS = {
  NEW: 'bg-red-100 text-red-800',
  'IN_PROGRESS': 'bg-yellow-100 text-yellow-800',
  RESOLVED: 'bg-green-100 text-green-800',
  CLOSED: 'bg-gray-100 text-gray-800'
};

// Source configuration with icons and colors
export const SOURCE_CONFIG = {
  EMAIL: {
    icon: 'Mail',
    label: 'Email',
    color: 'bg-blue-100 text-blue-700',
    iconColor: 'text-blue-600'
  },
  FACEBOOK: {
    icon: 'Facebook',
    label: 'Facebook',
    color: 'bg-blue-100 text-blue-700',
    iconColor: 'text-blue-600'
  },
  INSTAGRAM: {
    icon: 'Instagram',
    label: 'Instagram',
    color: 'bg-pink-100 text-pink-700',
    iconColor: 'text-pink-600'
  },
  WHATSAPP: {
    icon: 'MessageCircle',
    label: 'WhatsApp',
    color: 'bg-green-100 text-green-700',
    iconColor: 'text-green-600'
  },
  LINKEDIN: {
    icon: 'Linkedin',
    label: 'LinkedIn',
    color: 'bg-blue-100 text-blue-700',
    iconColor: 'text-blue-600'
  },
  TWILIO: {
    icon: 'Phone',
    label: 'SMS',
    color: 'bg-red-100 text-red-700',
    iconColor: 'text-red-600'
  },
  CHAT_WIDGET: {
    icon: 'MessageCircle',
    label: 'Chat',
    color: 'bg-purple-100 text-purple-700',
    iconColor: 'text-purple-600'
  }
};

export const TEMPLATE_RESPONSES = {
  acknowledgment: "Thank you for contacting us. We've received your complaint and will respond within 24 hours.",
  billing: "We understand your billing concern and are reviewing your account. Our billing team will contact you shortly.",
  shipping: "We apologize for the shipping delay. We're tracking your order and will provide an update within 24 hours.",
  product: "We're sorry to hear about the product issue. Our quality team is investigating and will respond soon.",
  refund: "We've received your refund request and are processing it according to our refund policy.",
  escalation: "Your complaint has been escalated to our senior team for immediate attention.",
  resolution: "We're pleased to inform you that your issue has been resolved. Please let us know if you need further assistance."
};